/* eslint-disable import/prefer-default-export */
export const goScrollTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};
